document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.en-source-page[data-en-page="enclave-science"] .science-card').forEach((card) => {
    card.tabIndex = 0;
    card.setAttribute('aria-label', card.querySelector('.science-card-base-info')?.textContent.trim() || 'Medical review board');
  });
  document.querySelectorAll('.en-source-page[data-en-page="enclave-reviews"]').forEach((root) => {
    const buttons = [...root.querySelectorAll('button[data-filter-tag]')];
    const cards = [...root.querySelectorAll('[data-review-tag]')];
    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(!button.dataset.filterTag));
      button.addEventListener('click', () => {
        const tags = button.dataset.filterTag.split(',').map((tag) => tag.trim()).filter(Boolean);
        buttons.forEach((item) => {
          item.classList.toggle('fc-reviews-tab--active', item === button);
          item.setAttribute('aria-pressed', String(item === button));
        });
        cards.forEach((card) => {
          const visible = !tags.length || tags.includes(card.dataset.reviewTag.trim());
          card.hidden = !visible;
          if (!visible) card.querySelectorAll('video').forEach((video) => video.pause());
        });
        root.querySelectorAll('.fc-reviews-empty').forEach((empty) => { empty.hidden = cards.some((card) => !card.hidden); });
      });
    });
  });
});
